import React, { useState, useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import QrPreview from './QrPreview'
import endpoints from 'app/effects/apis/endpointConfig'
import { usePlace } from 'commons/usePlace'
import { usePlaceLogo } from 'commons/usePlaceLogo'
import { Typography, Tooltip } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'
import clsx from 'clsx'
import Assets from 'app/configs/assetConfigs'
import { useAppName } from 'commons/usePartner'

const useStyle = makeStyles((theme) => ({
  qrButton: {
    width: 'max-content',
    color: '#00AFF0',
    '& svg': {
      fill: '#00AFF0',
      margin: '0px 3px',
    },
  },
  qrIcon: {
    fill: '#00AFF0',
    width: 15,
    marginRight: 8,
  },
  classClose: {
    cursor: 'pointer',
  },
  loaderContainer: {
    height: 500,
    overflow: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageContainer: {
    height: 500,
    overflow: 'auto',
    position: 'relative',
  },
  canvasBackground: {
    position: 'absolute',
    top: 50,
    left: 0,
    width: 528,
    height: 747,
    zIndex: 1,
    backgroundSize: 'contain',
  },
  canvasPreview: {
    position: 'relative',
    zIndex: 2,
  },
  qrButtonText: {
    color: '#00AFF0',
    fontWeight: '400',
    fontSize: '14px',
  },
}))

export const qrLoadingState = {
  INIT: 0,
  LOADING: 1,
  SUCCESS: 2,
}

export default ({ placeName }) => {
  const classes = useStyle()
  const [isOpenQrDialog, setIsOpenQrDialog] = useState(false)
  const [qrVersion, setQrVersion] = useState(new Date().valueOf())
  const place = usePlace()
  const { formatMessage } = useIntl()
  const [logo, setLogo] = useState('')
  const appName = useAppName()

  const tmpLogo = usePlaceLogo()
  useEffect(() => {
    setLogo(tmpLogo ? tmpLogo + '?v=' + qrVersion : null)
  }, [tmpLogo, qrVersion])
  let backgroundUrl = Assets.qr.background
  const openModal = () => {
    setIsOpenQrDialog(true)
    setQrVersion(new Date().valueOf())
  }

  return (
    <>
      <Tooltip
        title={formatMessage({ id: 'qr.hover' }, { appName })}
        placement="bottom"
      >
        <div
          onClick={openModal}
          className={clsx(
            classes.qrButton,
            'flex items-center cursor-pointer ml-10',
          )}
        >
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 7.5V2.5H7V4.5H4V7.5H2ZM2 22.5V17.5H4V20.5H7V22.5H2ZM17 22.5V20.5H20V17.5H22V22.5H17ZM20 7.5V4.5H17V2.5H22V7.5H20ZM17.5 18H19V19.5H17.5V18ZM17.5 15H19V16.5H17.5V15ZM16 16.5H17.5V18H16V16.5ZM14.5 18H16V19.5H14.5V18ZM13 16.5H14.5V18H13V16.5ZM16 13.5H17.5V15H16V13.5ZM14.5 15H16V16.5H14.5V15ZM13 13.5H14.5V15H13V13.5ZM19 5.5V11.5H13V5.5H19ZM11 13.5V19.5H5V13.5H11ZM11 5.5V11.5H5V5.5H11ZM9.5 18V15H6.5V18H9.5ZM9.5 10V7H6.5V10H9.5ZM17.5 10V7H14.5V10H17.5Z"
              fill="#646464"
            />
          </svg>
          <Typography
            className={clsx(classes.qrButtonText, 'flex-none h-auto')}
          >
            <FormattedMessage id="qr.button.second" />
          </Typography>
        </div>
      </Tooltip>
      <QrPreview
        open={isOpenQrDialog}
        onClose={() => setIsOpenQrDialog(false)}
        classes={classes}
        placeName={placeName}
        backgroundImageURL={backgroundUrl}
        placeLogoImageURL={logo}
        qrCodeImageURL={endpoints.qr({
          placeId: place.id,
          version: qrVersion,
        })}
      />
    </>
  )
}
